var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css } from 'styled-components';

/**
 * Get Styled Component option theme
 * @param options GetOptionThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getOptionTheme = function getOptionTheme(options) {
  var look = options.look;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n\n    &:hover {\n      background-color: ", ";\n    }\n\n    &[aria-selected='true'] {\n      background-color: ", ";\n    }\n\n    &[aria-disabled='true'] {\n      background-color: ", ";\n      color: ", ";\n    }\n  "])), function (_ref) {
    var theme = _ref.theme;
    return theme.option[look].backgroundColor;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.option[look].textColor;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.option[look].backgroundColorHover;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.option[look].backgroundColorSelected;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.option[look].backgroundColor;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.option[look].textColorDisabled;
  });
};
export { getOptionTheme };